import { render, staticRenderFns } from "./HeaderLogado.vue?vue&type=template&id=30d81f5a"
import script from "./HeaderLogado.vue?vue&type=script&lang=js"
export * from "./HeaderLogado.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogado.vue?vue&type=style&index=0&id=30d81f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports